"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StepsInfo = function StepsInfo(_ref) {
  var totalSteps = _ref.totalSteps,
      currentStep = _ref.currentStep;
  return _react.default.createElement("div", {
    className: "steps--numbers"
  }, "Step ", _react.default.createElement("span", null, currentStep), " of ", _react.default.createElement("span", null, totalSteps));
};

StepsInfo.propTypes = {
  totalSteps: _propTypes.default.number.isRequired,
  currentStep: _propTypes.default.number.isRequired
};
var _default = StepsInfo;
exports.default = _default;
StepsInfo.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "StepsInfo",
  "props": {
    "totalSteps": {
      "type": {
        "name": "number"
      },
      "required": true,
      "description": ""
    },
    "currentStep": {
      "type": {
        "name": "number"
      },
      "required": true,
      "description": ""
    }
  }
};